import Udesk from 'Udesk';

export const enableTranslate = (inspectDataSource: number) => {
    return [
        Udesk.enums.inspectDataSources.voiceCall.id,
        Udesk.enums.inspectDataSources.textDialogue.id,
        Udesk.enums.inspectDataSources.ticket.id,
        Udesk.enums.inspectDataSources.wechatDialogue.id,
        Udesk.enums.inspectDataSources.wechatRadio.id,
        Udesk.enums.inspectDataSources.eComment.id,
        Udesk.enums.inspectDataSources.mComment.id,
        Udesk.enums.inspectDataSources.videoCall.id,
        Udesk.enums.inspectDataSources.survey.id,
        Udesk.enums.inspectDataSources.feishuGroup.id,
        Udesk.enums.inspectDataSources.taobao.id,
    ].includes(inspectDataSource);
};
